// validators/string.ts
import { assertSchema, assertValidation } from "../errors.mjs";
import { AbstractValidator, makeValidatorFactory } from "../types.mjs";
var AnyStringValidator = class extends AbstractValidator {
  validate(value) {
    assertValidation(typeof value === "string", 'Value is not a "string"');
    return value;
  }
};
var StringValidator = class extends AbstractValidator {
  maxLength;
  minLength;
  pattern;
  brand;
  constructor(constraints = {}) {
    super();
    const {
      minLength = 0,
      maxLength = Number.MAX_SAFE_INTEGER,
      pattern
    } = constraints;
    if ("brand" in constraints) this.brand = constraints.brand;
    assertSchema(minLength >= 0, `Constraint "minLength" (${minLength}) must be non-negative`);
    assertSchema(maxLength >= 0, `Constraint "maxLength" (${maxLength}) must be non-negative`);
    assertSchema(minLength <= maxLength, `Constraint "minLength" (${minLength}) is greater than "maxLength" (${maxLength})`);
    this.maxLength = maxLength;
    this.minLength = minLength;
    this.pattern = pattern;
  }
  validate(value) {
    assertValidation(typeof value === "string", 'Value is not a "string"');
    assertValidation(
      value.length >= this.minLength,
      `String must have a minimum length of ${this.minLength}`
    );
    assertValidation(
      value.length <= this.maxLength,
      `String must have a maximum length of ${this.maxLength}`
    );
    assertValidation(
      this.pattern ? this.pattern.test(value) : true,
      `String does not match required pattern ${this.pattern}`
    );
    return value;
  }
};
function stringValidatorFactory(constraints) {
  return new StringValidator(constraints);
}
var string = makeValidatorFactory(new AnyStringValidator(), stringValidatorFactory);
export {
  AnyStringValidator,
  StringValidator,
  string,
  stringValidatorFactory
};
//# sourceMappingURL=string.mjs.map
